export default "__VITE_ASSET__BKUq3Mjh__"